import { useMemo, useState, useEffect, useCallback } from "react";
import { TimerPopup } from "@kalyzee/escaet-ui";
import { enlistInMeetingActivityRoom } from "../../helpers/meeting";
import { ActivityData } from "../../interfaces/populatedData";

export interface MeetingActivityJoinPopupProps {
  meetingId: string;
  activityData: ActivityData;
  selfSessionId: string;
}

export const MeetingActivityJoinPopup = ({
  meetingId,
  activityData,
  selfSessionId,
}: MeetingActivityJoinPopupProps) => {
  const [loading, setLoading] = useState(false);
  const timeout = 10000;

  const isInActivity = useMemo(
    () => activityData?.sessions.some(session => session.id === selfSessionId), 
    [activityData, selfSessionId],
  );
  
  const isConfirmedInActivity = useMemo(
    () => activityData?.confirmedSessions.some(session => session.id === selfSessionId), 
    [activityData, selfSessionId],
  );

  const onJoin = useCallback(() => {
    enlistInMeetingActivityRoom(meetingId);
    setLoading(true);
  }, [meetingId]);

  useEffect(() => {
    if (!isConfirmedInActivity) {
      setLoading(false);
    }
  }, [isConfirmedInActivity]);

  useEffect(() => {
    if (isInActivity && !isConfirmedInActivity) {
      const timer = setTimeout(onJoin, timeout);
      return () => clearTimeout(timer);
    }
  }, [isInActivity, isConfirmedInActivity, onJoin]);

  const getText = () => {
    if (activityData.mode === "all_leaders") {
      return "L'expert s'adresse à tous les leaders";
    } else if (activityData.mode === "one_leader") {
      return "L'expert souhaite vous parler en privé"; 
    } else if (activityData.mode === "one_group") {
      return "L'expert s'adresse à votre groupe";
    } else {
      return "L'expert vous fait monter au tableau";
    }
  };

  if (isInActivity && activityData.requiresConfirmation && !isConfirmedInActivity) {
    return (
      <TimerPopup
        loading={loading}
        text={getText()}
        subText="Une nouvelle conversation va s'ouvrir"
        durationInSeconds={10}
        overButtonText="Rejoindre"
        onOver={onJoin}
      />
    );
  }

  return null;
};